import { Box, Flex, Link as CLink, Text } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router'
import { useT } from '~/i18n/use-t'

const link = {
  display: 'inline-flex',
  alignItems: 'center',
  minH: '12',
  px: 1,
  color: 'fg.muted',
  textDecoration: 'none',
  _hover: { color: 'fg', textDecoration: 'underline' },
} as const

/**
 * The footer of every member screen (ruling R1, design spec 2026-10-30 §5): one centred line, "Privacy Policy ·
 * vocdoni.io", and nothing else. Each link is a 48 px tall target; the text is 16 px like everything a member reads.
 * The credits live in the privacy page and on the city step (R4).
 */
export function MiniFooter() {
  const { t } = useT()
  return (
    <Box as='footer' data-mini-footer='' color='fg.muted'>
      <Flex justify='center' align='center' wrap='wrap' columnGap={1}>
        <CLink asChild {...link}>
          <RouterLink to='/privacy'>{t('footer.privacyPolicy')}</RouterLink>
        </CLink>
        <Text as='span' aria-hidden>
          ·
        </Text>
        <CLink href='https://vocdoni.io' target='_blank' rel='noopener noreferrer' {...link}>
          {t('footer.vocdoni')}
        </CLink>
      </Flex>
    </Box>
  )
}
